import LetterOfCredit from "./LetterOfCredit";

const LetterOfCreditConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/letterOfCredit',
            element: <LetterOfCredit />,
        },
    ],
};

export default LetterOfCreditConfig;
